<template>
    <div id="back-to-top" class="go-top" v-if="isVisible" @click="backToTop">
        <!--<i class="arrow up"></i>-->
        <img alt="Nach oben" class="arrow-img" src="/img/ic_chevron_top_ffffff.svg" />
    </div>
</template>

<script>

    export default {
        data : function(){
            return {
                isVisible : false,
            };
        },
        methods : {
            initToTopButton : function(){
                if (typeof jQuery === 'undefined') {
                    console.warn('BackToTop.vue: jQuery not available');
                    return;
                }
                if (typeof $ === 'undefined') {
                    $ = jQuery;
                }
                $(document).bind('scroll', function(){
                    var backToTopButton = $('.go-top');
                    if ($(document).scrollTop() > 250) {
                        backToTopButton.addClass('is-visible');
                        this.isVisible = true;
                    } else {
                        backToTopButton.removeClass('is-visible');
                        this.isVisible = false;
                    }
                }.bind(this));
            },
            backToTop : function(){
                if (typeof jQuery === 'undefined') {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                    return;
                }
                if (typeof $ === 'undefined') {
                    $ = jQuery;
                }
                $('html,body').stop().animate({
                    scrollTop : 0,
                }, 'slow', 'swing');
            },
        },
        mounted : function(){
            this.$nextTick(function(){
                this.initToTopButton();
            });
        },
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .go-top {
        background-color:$color-nochvielvor-black;
        position: fixed;
        width: 55px;
        height: 55px;
        display: block;
        right: 24px;
        bottom: 100px;
        border: none;
        opacity: 0;
        text-align: center;
        @media screen and (min-width: 768px) {
            right: 30px;
            bottom: 30px;
        }
        @media screen and (min-width: 1200px) {
            right: 24px * $factor-1200;
            bottom: 24px * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            right: 24px * $factor-1440;
            bottom: 24px * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            right: 24px * $factor-1920;
            bottom: 24px * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            right: 24px * $factor-2400;
            bottom: 24px * $factor-2400;
        }
        z-index: -1;
        .fa {
            color: white;
            font-size: 22px;
        }
        &:hover {
            opacity: 1;
            //background-color: rgb(1, 14, 27);
            //background-color: rgba(1, 14, 27, .9);
        }
        &.is-visible {
            opacity: 1;
            z-index: 4;
            transition: all .4s ease-in;
        }
        .arrow {
            border: solid white;
            border-width: 0 3px 3px 0;
            display: inline-block;
            padding: 4px;
            &.up {
                transform: rotate(-135deg);
                -webkit-transform: rotate(-135deg);
            }
        }
        .arrow-img{
            padding-top: 17px;
        }
    }

</style>
